<template>
  <div>
    <UserComments
      v-if="winShows.commentsShow"
      @close="setShow('commentsShow', false)"
    />
    <KeysPopup v-if="winShows.keysShow" @close="setShow('keysShow', false)" />
    <MarkersPopup
      v-if="winShows.marksShow"
      @close="setShow('marksShow', false)"
    />
    <LinksPopup
      v-if="winShows.linksShow"
      @close="setShow('linksShow', false)"
    />
  </div>
</template>

<script>
import UserComments from "@/components/popupMenu/MenuOptions/tools/personalExtensions/CommentsPopup.vue";
import KeysPopup from "@/components/popupMenu/MenuOptions/tools/personalExtensions/KeysPopup.vue";
import MarkersPopup from "@/components/popupMenu/MenuOptions/tools/personalExtensions/MarkersPopup.vue";
import LinksPopup from "@/components/popupMenu/MenuOptions/tools/personalExtensions/LinksPopup.vue";

export default {
  components: { UserComments, KeysPopup, MarkersPopup, LinksPopup },
  computed: {
    winShows() {
      return this.$store.state.commonWin;
    },
  },
  methods: {
    setShow(win, show) {
      this.$store.dispatch("commonWin/setShow", { type: win, show });
    },
  },
};
</script>

<style lang="scss" scoped></style>
